import(/* webpackMode: "eager" */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/app/(root)/(main)/blog/[slug]/_components/PostContent/PostContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/app/(root)/(main)/blog/[slug]/_components/PostViewCounter.tsx");
